import { ReturnProductListComponent } from './return-product-list.component';
export default ReturnProductListComponent;
